export const FIND_ALL = `${process.env.REACT_APP_API_TALK_URL}/talk`;
export const API_BASE_URL = `${process.env.REACT_APP_API_URL_USER_DATA}/talk`;

// export const API_BASE_URL = "http://localhost:5002/api/v1/talk"
